import { Container, Typography } from '@mui/material';

const PrivacyPage = () => {
  const today = new Date().toLocaleDateString();

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      {/* Title */}
      <Typography variant="h3" gutterBottom>
        Privacy Policy
      </Typography>

      {/* Effective date */}
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Last updated: {today}
      </Typography>

      {/* 1. Introduction */}
      <Typography variant="h5" gutterBottom>
        1. Purpose
      </Typography>
      <Typography component="p" sx={{ mb: 2 }}>
        Street Ratings is committed to protecting your privacy. This statement explains what
        information the application collects, how it is used and stored, and the choices available
        to you.
      </Typography>

      {/* 2. Data we collect */}
      <Typography variant="h5" gutterBottom>
        2. Information we collect
      </Typography>
      <Typography component="p" sx={{ mb: 1.5 }}>
        Street Ratings does not collect personal data that can identify you directly. The
        application gathers only the data listed below.
      </Typography>
      <Typography component="p" sx={{ pl: 2, mb: 2 }}>
        •&nbsp;<strong>Crash logs</strong> - Diagnostic reports may be sent to our servers to
        investigate errors. These logs contain no personally identifiable information.
        <br />
        •&nbsp;<strong>Location data</strong> - GPS coordinates are used temporarily to find nearby
        reviews. Location data is processed ephemerally and cached only for performance.
        <br />
        •&nbsp;<strong>Service logs</strong> - General server logs are retained between 14&nbsp;days
        and indefinitely, depending on operational requirements.
      </Typography>

      {/* 3. How we use information */}
      <Typography variant="h5" gutterBottom>
        3. How we use information
      </Typography>
      <Typography component="p" sx={{ mb: 2 }}>
        The data above is used solely to deliver core functionality, improve rating accuracy,
        enhance performance, and diagnose technical issues. We do not sell or rent any information
        to third-party advertisers.
      </Typography>

      {/* 4. Third-party services */}
      <Typography variant="h5" gutterBottom>
        4. Third-party services
      </Typography>
      <Typography component="p" sx={{ mb: 1.5 }}>
        Street Ratings is hosted on Google Cloud Platform services. Data handled by GCP remains
        subject to Google's own retention and security policies. When the app displays
        Google-sourced reviews, those reviews follow Google's retention schedule, currently thirty
        days.
      </Typography>

      {/* 5. Your choices */}
      <Typography variant="h5" gutterBottom>
        5. Your choices
      </Typography>
      <Typography component="p" sx={{ mb: 2 }}>
        Future releases will offer in-app settings to disable analytics or clear cached location
        data. You may also limit analytics at the device level through your operating-system privacy
        controls.
      </Typography>

      {/* 6. Children */}
      <Typography variant="h5" gutterBottom>
        6. Children
      </Typography>
      <Typography component="p" sx={{ mb: 2 }}>
        The application is suitable for all ages but is not directed at children under thirteen. We
        do not knowingly collect information from anyone under that age.
      </Typography>

      {/* 7. International users */}
      <Typography variant="h5" gutterBottom>
        7. International users
      </Typography>
      <Typography component="p" sx={{ mb: 2 }}>
        Street Ratings is currently offered to users in Australia. International availability may
        expand. When it does, the service will comply with applicable privacy regulations in each
        region.
      </Typography>

      {/* 8. Changes */}
      <Typography variant="h5" gutterBottom>
        8. Changes to this policy
      </Typography>
      <Typography component="p" sx={{ mb: 2 }}>
        This policy may be updated as the application evolves. Any significant changes will be
        posted on this page and will take effect upon posting.
      </Typography>

      {/* 9. Contact */}
      <Typography variant="h5" gutterBottom>
        9. Contact
      </Typography>
      <Typography component="p">
        For questions about privacy, email: streetratings123[at]gmail[dot]com with the subject
        line&nbsp; "Privacy".
      </Typography>
    </Container>
  );
};

export { PrivacyPage };
